import { useMediaQuery } from "@mui/material";
import { AcademicRequestType, MOBILE_BREAKPOINT } from "utils/constants";
import {
  Datagrid,
  DateField,
  FunctionField,
  List,
  ReferenceField,
  SelectField,
  SimpleList,
  TextField,
  TopToolbar,
} from "react-admin";
import { administrationRequests } from "api/administrationApi";
import { AcademicRequestStatus, AcademicRequestTypeChoices } from "utils/choices";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import { EmptyList } from "server/components";
import { settings } from "app";
import ChangeStatusDialog from "./components/ChangeStatusDialog";
import StudentCreditRequestDialog from "./components/StudentCreditRequestDialog";
import { AcademicRequestExporter } from "./XlsxExporter";
import { ExportXlsButton } from "features/ExportXlsxButton";
import { accountRequests } from "api/accountApi";
import { MobileListRow } from "features/MobileListRow";

const ListAcademicRequests = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);

  const ListActions = () => {
    return (
      <TopToolbar>
        <ExportXlsButton exporter={AcademicRequestExporter} />
      </TopToolbar>
    );
  };

  return (
    <List
      actions={<ListActions />}
      title="Академични заявки"
    >
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <MobileListRow fields={[{ label: "Факултетен номер", value: record.facultyNumber }]} />
          )}
          secondaryText={record => (
            <div>
              <MobileListRow
                fields={[
                  {
                    label: "Студент",
                    value: (
                      <ReferenceField
                        reference={accountRequests.getUsersSelect()}
                        source="userId"
                        label="Студент"
                      >
                        <FunctionField
                          render={rec =>
                            rec.secondName
                              ? `${rec.firstName} ${rec.secondName} ${rec.lastName}`
                              : `${rec.firstName} ${rec.lastName}`
                          }
                        />
                      </ReferenceField>
                    ),
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Специалност",
                    value: (
                      <ReferenceField
                        source="specialityId"
                        label="Специалност"
                        reference={administrationRequests.getSpecialitiesSelect()}
                      >
                        <TextField source="name" />
                      </ReferenceField>
                    ),
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Тип",
                    value: (
                      <SelectField
                        source="type"
                        choices={AcademicRequestTypeChoices}
                      />
                    ),
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Създаден",
                    value: (
                      <DateField
                        source="createdOn"
                        locales="bg-BG"
                        showTime
                      />
                    ),
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Статус",
                    value: record.status === 1 ? "Чакащ" : record.status === 2 ? "Готов" : "Отказан",
                  },
                ]}
              />
            </div>
          )}
          tertiaryText={record => (
            <>
              {record.type === AcademicRequestType.CreditReport ? (
                <SecuredComponent permission={permissions.canGenerateAcademicRequestDocuments}>
                  <StudentCreditRequestDialog record={record} />
                </SecuredComponent>
              ) : null}
              <SecuredComponent permission={permissions.canChangeAcademicRequestStatus}>
                <ChangeStatusDialog record={record} />
              </SecuredComponent>
            </>
          )}
        ></SimpleList>
      ) : (
        <Datagrid
          rowClick={false}
          bulkActionButtons={false}
        >
          <ReferenceField
            reference={accountRequests.getUsersSelect()}
            source="userId"
            label="Студент"
            sortable={false}
          >
            <FunctionField
              render={rec =>
                rec.secondName
                  ? `${rec.firstName} ${rec.secondName} ${rec.lastName}`
                  : `${rec.firstName} ${rec.lastName}`
              }
            />
          </ReferenceField>
          <TextField
            source="facultyNumber"
            label="Факултетен номер"
            sortable={false}
          />
          <ReferenceField
            source="specialityId"
            label="Специалност"
            reference={administrationRequests.getSpecialitiesSelect()}
            sortable={false}
          >
            <TextField source="name" />
          </ReferenceField>
          <SelectField
            source="type"
            label="Тип"
            choices={AcademicRequestTypeChoices}
          />
          <DateField
            source="createdOn"
            label="Създаден"
            locales="bg-BG"
            showTime
          />
          <SelectField
            source="status"
            label="Статус"
            choices={AcademicRequestStatus}
          />
          <SecuredComponent permission={permissions.canGenerateAcademicRequestDocuments}>
            <FunctionField
              render={record =>
                record.type === AcademicRequestType.CreditReport ? <StudentCreditRequestDialog record={record} /> : null
              }
            />
          </SecuredComponent>
          <SecuredComponent permission={permissions.canChangeAcademicRequestStatus}>
            <FunctionField
              label="Статус"
              render={record => <ChangeStatusDialog record={record} />}
            />
          </SecuredComponent>
        </Datagrid>
      )}
    </List>
  );
};

export default ListAcademicRequests;
